var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.qrUrl || _vm.format != 'qr')?_c('img',{key:_vm.id,ref:"barcode",attrs:{"src":_vm.qrUrl}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }